import ThemeModal from "components/Common/ThemeModal"
import { useFilteredVehicleOptions } from "hooks/stockFilterHook"
import CustomerForm from "pages/CustomerPages/Customer/CustomerForm"
import { useCallback, useMemo } from "react"

const QuotationCustomerForm = ({
  isOpen,
  toggle,
  onCustomer,
  initialData = null,
  title = "Add New Customer",
  submitText = "Add Customer",
}) => {
  const {
    isLoading: optionLoading,
    raw: rawData,
    refetch: refetchOptions,
  } = useFilteredVehicleOptions()

  const customerData = rawData?.customer ?? {}

  // Prepare options for CustomerForm
  const formOptions = useMemo(
    () => ({
      designations: customerData?.designations ?? [],
      departments: customerData?.departments ?? [],
      companies: customerData?.companies ?? [],
      customerTypes: customerData?.customer_types ?? [],
      areas: customerData?.customer_areas ?? [],
      cities: customerData?.customer_city ?? [],
    }),
    [customerData]
  )

  const isLoading = false

  // Handle form submission
  const handleSubmit = useCallback(
    async (values, { resetForm }) => {
      onCustomer(values, initialData)
      resetForm()
      toggle()
    },
    [refetchOptions, toggle]
  )

  const handleCancel = useCallback(() => {
    toggle()
  }, [toggle])

  return (
    <ThemeModal isOpen={isOpen} toggle={toggle} title={title}>
      <CustomerForm
        initialData={initialData}
        options={formOptions}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isEdit={false}
        isLoading={isLoading}
        submitButtonText={submitText}
        cancelButtonText="Cancel"
        showAdditionalInfo={true}
      />
    </ThemeModal>
  )
}

export default QuotationCustomerForm
